import { Link } from "react-router-dom";
import { useI18n } from "../i18n/index.js";
import styles from "./NotFound.module.css";

export function NotFound({ message }: { message?: string }) {
  const { t } = useI18n();

  return (
    <main className={styles.main}>
      <h1>{t("page.notFound.title")}</h1>
      <p>{message ?? t("page.notFound.body")}</p>
      <Link to="/">{t("page.notFound.backHome")}</Link>
    </main>
  );
}
